import { render, staticRenderFns } from "./SPRWarning.vue?vue&type=template&id=8bddcbda&scoped=true"
import script from "./SPRWarning.vue?vue&type=script&lang=js"
export * from "./SPRWarning.vue?vue&type=script&lang=js"
import style0 from "./SPRWarning.vue?vue&type=style&index=0&id=8bddcbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bddcbda",
  null
  
)

export default component.exports